/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCustomWarning
 */
export interface MelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCustomWarning
     */
    message?: string | null;
}

export function MelcoModelsCustomWarningFromJSON(json: any): MelcoModelsCustomWarning {
    return MelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function MelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function MelcoModelsCustomWarningToJSON(value?: MelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


